export enum LOGIN_STATUS_ENUM {
	AUTH_STAGE = 'authStage',
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESS = 'success',
	ERROR = 'error',
}

export interface IdentityProviderState {
	status: LOGIN_STATUS_ENUM;
}
